/**
 * Home map (#/overview) — pure access + rollout policy (no DOM).
 *
 * tip587 hard-cut: trust ``/auth/me.home_map_ui_enabled`` only.
 * Env gate is ``HOME_MAP_UI_ENABLED`` / ``HOME_MAP_UI_AUDIENCE``.
 */

/** Console roles that may use the map when the server enables it (UX hint only). */
export function canAccessOpsMapConsole(me) {
  if (!me) return false;
  const r = String(me.role || "").trim();
  if (r === "superadmin" || r === "sa_staff") return true;
  if (r === "admin") return true;
  if (r === "user" && String(me.manager_admin || "").trim()) return true;
  return false;
}

/** True when this principal may use the Home map (server-computed). */
export function isHomeMapUiRolloutEnabled(me) {
  if (!me) return false;
  return !!me.home_map_ui_enabled;
}

/** @deprecated tip587 — use isHomeMapUiRolloutEnabled */
export function isOpsMapUiRolloutEnabled(me) {
  return isHomeMapUiRolloutEnabled(me);
}

/** Sidebar, routes, and preloads — trust Home map flag from ``/auth/me``. */
export function canUseHomeMap(me) {
  return isHomeMapUiRolloutEnabled(me);
}

/** @deprecated tip587 — use canUseHomeMap (alias kept for call sites). */
export function canUseOpsMap(me) {
  return canUseHomeMap(me);
}
